import dayjs from 'dayjs';
import _capitalize from 'lodash/capitalize';
import { Button } from 'antd';

import { formatDollarsFromCents } from 'utilities/helpers';

import { OfferPaymentsTable, applyRowClass } from '../OfferPaymentsTable';

const STATUS_FILTERS = [
  { text: 'Posted', value: 'POSTED' },
  { text: 'Pending', value: 'PENDING' },
  { text: 'Returned', value: 'RETURNED' },
  { text: 'Scheduled', value: 'SCHEDULED' },
  { text: 'Executed', value: 'EXECUTED' },
];

const getColumns = ({ onEditPayment, showEditPayment, showStatus }) =>
  [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      sorter: (a, b) => dayjs(a.date).unix() - dayjs(b.date).unix(),
      render: (date) => {
        return dayjs(date).format('LL');
      },
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      sorter: (a, b) => a.amount - b.amount,
      render: (_, record) => (
        <>
          {formatDollarsFromCents(record.amount)}
          {!record.type && showEditPayment && (
            <Button
              type="link"
              onClick={() => onEditPayment(record)}
              style={{ marginLeft: 'var(--spacing)' }}
            >
              Edit Payment
            </Button>
          )}
        </>
      ),
    },
    showStatus && {
      title: 'Status',
      dataIndex: '',
      key: 'status',
      filters: STATUS_FILTERS,
      filterMode: 'tree',
      onFilter: (value, record) => {
        if (value === 'SCHEDULED' && !record.type) {
          return true;
        }
        return record.type === value;
      },
      sorter: (a, b) => {
        const statusA = a.type || 'SCHEDULED';
        const statusB = b.type || 'SCHEDULED';
        return statusA.localeCompare(statusB);
      },
      render: (_, record) => _capitalize(record.type || 'SCHEDULED'),
    },
  ].filter(Boolean);

const RecoveriesScheduleTable = ({
  data,
  onEditPayment,
  showEditPayment,
  showStatus,
}) => (
  <OfferPaymentsTable
    rowClassName={applyRowClass}
    columns={getColumns({ onEditPayment, showEditPayment, showStatus })}
    data={data}
    length={7}
    style={{ marginBottom: 'var(--spacing-sm)' }}
    showSelectionActions={true}
    showCopyButton={false}
  />
);

export default RecoveriesScheduleTable;
